export default __webpack_public_path__ + "static/media/cancel.fec25231.svg";